module.exports = __webpack_public_path__ + "img/1154578835.04b824b5.jpg";